/**
 * @desc 产品BOM-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.productBom.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
